export const question = [
  {
    id: 1,
    question: "Eligibility & Requirements",
    answer: [
      {
        item: "Women entrepreneurs above 18 years of age.",
      },
      {
        item: "For non-individual businesses, at least 51% shareholding and controlling stake must be held by a woman entrepreneur.",
      },
      {
        item: "Applicant must not be in default with any financial institution.",
      },
    ],
  },
  {
    id: 2,
    question: "Purpose",
    answer: [
      {
        item: "The Women Power Loan is designed to support women in starting new enterprises or scaling existing businesses in manufacturing, trading, services, or agriculture-allied sectors.",
      },
    ],
  },
  {
    id: 3,
    question: "Quantum of Finance",
    answer: [
      {
        item: "Minimum loan amount: K500,000",
      },
      {
        item: "Maximum loan amount: K10,000,000",
      },
    ],
  },
  {
    id: 4,
    question: "Security",
    answer: [
      {
        item: "Primary Security: Assets created out of bank finance.",
      },
      {
        item: "Collateral Security: Minimum 50% collateral of the loan limit.",
      },
      {
        item: "Guarantee Scheme: 50% coverage under the Credit Guarantee Scheme.",
      },
    ],
  },
  {
    id: 5,
    question: "Repayment Period",
    answer: [
      {
        item: "Maximum repayment period: 84 months (7 years).",
      },
      {
        item: "Moratorium period: Up to 18 months.",
      },
    ],
  },
  {
    id: 6,
    question: "Processing Fee",
    answer: [
      {
        item: "Processing fee: 1.75% of the loan amount.",
      },
    ],
  },
];
